import * as _Icon from './components';
import * as _icons from './urls';

export const Icon = _Icon;
export const icons = _icons;
